import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchTotalAdsProps = {
  startDate: Moment;
  endDate: Moment;
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchTotalAds = (filters: FetchTotalAdsProps) => void;

const fetchTotalAds = ({
  startDate,
  endDate,
  clusters = [],
  partners = [],
  origami,
}: FetchTotalAdsProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("total_ads", dispatch, params);
};

export default fetchTotalAds;
